// extracted by mini-css-extract-plugin
export default {"top":"HeaderLeave_top__hYeCv","box":"HeaderLeave_box__D8iTb","addButton":"HeaderLeave_addButton__MNh99"};